import { IStackProps, Stack as FabricStack } from "@fluentui/react";

export type StackProps = IStackProps;

export const Stack = FabricStack;
